// import lostMicrophone from "../modules/lostMicrophone";
import openAllQuestion from '../modules/openAllQuestion';
import {
	createElementMobaile,
	removeLocalStoregeQuestion,
	scrollDown
} from './LitlModules';
import burgerMenu from './burgerMenuFunction';
// import clickIphone from "./clickIphone";
import quetionAdd from './quetionAdd';
import widjetCircolLev from './widjetCircolLev';
import { mobailCle, CountElementIsDOM } from './whereStCicle';

const wrapperTutle = document.querySelector('.wrapperTutle'),
	buttonHolder = document.querySelector('.buttonHolder'),
	body = document.body,
	html = document.documentElement;
let selectorEndIteration = 0;
const changeLevel = targetBtn => {
	// console.log(`вызво changeLevel ${targetBtn} ${selectorListQ} ${btnsStart}`);
	// console.log(targetBtn);
	let time,
		navel = document.querySelector('#navel'),
		burger_men = document.querySelector('#burger_men'),
		btnBurge_men = document.querySelector('#btnBurge_men'),
		spanBurger_man = document.querySelector('#spanBurger_man'),
		overlowBurger = document.querySelector('#overlowBurger'),
		sel = 'tick',
		localSel = targetBtn.classList[2],
		width = Math.max(
			body.scrollWidth,
			body.offsetWidth,
			html.clientWidth,
			html.scrollWidth,
			html.offsetWidth
		),
		btn = document.querySelector('.staet'),
		btnsStart = document.querySelectorAll('.button');

	// console.log(selectorEndIteration);
	window.modeloderad = false;

	if (
		document.querySelector('#navel').parentElement ==
		document.querySelector('.time__segment')
	) {
		document
			.querySelector('#burger_men')
			.appendChild(document.querySelector('#navel'));
	}

	//  const todoNumOne = document.querySelector('.tinRightIn');
	if (!document.querySelector('.tinRightIn')) {
		wrapperTutle.classList.add('pps');
	}
	//  let time;
	time = setTimeout(() => {
		buttonHolder.classList.remove('hide');
		btnsStart.forEach(span => {
			span.nextElementSibling.classList.remove('textActiveLevel');
		});
		targetBtn.nextElementSibling.classList.add('textActiveLevel');
		clearTimeout(time);
		time = null;
	}, 100);

	// selectorListQ = [];
	switch (targetBtn.classList[2]) {
		case 'tick':
			selectorEndIteration = window.objectAllCor[localSel];
			sel = 'tick';
			break;
		case 'cross':
			selectorEndIteration = window.objectAllCor[localSel];
			sel = 'cross';
			break;
		case 'heart':
			selectorEndIteration = window.objectAllCor[localSel];
			sel = 'heart';
			break;
		case 'flower':
			selectorEndIteration = window.objectAllCor[localSel];
			sel = 'flower';
			break;
	}

	// console.log(selectorEndIteration);

	localSel = null;
	// if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && width <= 775) {
	if (global.mobaleMOde && width <= 775) {
		// //         // код для мобильных устройств
		// if(!btn.classList.contains('hide')){
		//   btn.classList.add('hide');
		// }
		if (navel.classList.contains('burger-menu_nav')) {
			// бесполезная строка по моим предполоениям
			// let menu = document.querySelector('.burger-menu');s
			setTimeout(() => {
				document
					.querySelector('.burger-menu')
					.classList.remove('burger-menu_active');
				body.style = 'overflow: visible;';
			}, 700);
		} else {
			navel.classList.add('burger-menu_nav');
			burger_men.classList.add('burger-menu');
			btnBurge_men.classList.add('burger-menu_button');
			spanBurger_man.classList.add('burger-menu_lines');
			overlowBurger.classList.add('burger-menu_overlay');

			burgerMenu('.burger-menu');
		}

		if (
			!document
				.querySelector('.downloadedBtn')
				.children[0].classList.contains('fabSegment')
		) {
			createElementMobaile();
		}

		const iconMaterialOpenAll = document.querySelector('.icon-material_gp');
		const elementList = document.querySelector('.gp_segment');

		elementList.removeEventListener('click', scrollDown);

		// elementList.removeEventListener('click', addLisenCicle);
		elementList.addEventListener(
			'click',
			() => {
				console.log(selectorEndIteration);
				mobailCle(
					CountElementIsDOM(),
					selectorEndIteration - CountElementIsDOM(),
					true
				);

				selectorEndIteration = 0;
				console.log(selectorEndIteration);
			},
			{ once: true }
		);

		// console.log(selectorEndIteration);
		// const addLisenCicle = () => {
		// 	console.log(selectorEndIteration);
		// 	mobailCle(
		// 		CountElementIsDOM(),
		// 		selectorEndIteration - CountElementIsDOM(),
		// 		true
		// 	);
		// 	console.log(selectorEndIteration);

		// 	selectorEndIteration = 0;
		// 	console.log(selectorEndIteration);

		// };
		// elementList.addEventListener('click', addLisenCicle, { once: true });

		iconMaterialOpenAll.parentElement.setAttribute(
			'data-tooltip',
			'Показать все'
		);
		iconMaterialOpenAll.classList.remove('icon-material_scrollDown');
	} else {
		// код для обычных устройств
		if (btn.classList.contains('hide')) {
			btn.classList.remove('hide');
		}
		openAllQuestion(sel);
		buttonHolder.classList.add('holeOut');

		if (navel.classList.contains('burger-menu_nav')) {
			navel.classList.remove('burger-menu_nav');
			burger_men.classList.remove('burger-menu');
			btnBurge_men.classList.remove('burger-menu_button');
			spanBurger_man.classList.remove('burger-menu_lines');
			overlowBurger.classList.remove('burger-menu_overlay');
		}

		buttonHolder.classList.remove('holeOut');

		buttonHolder.classList.add('buttonHolderStatic');

		if (!buttonHolder.classList.contains('bord')) {
			buttonHolder.classList.add('hide');
			buttonHolder.classList.add('bord');
		}
		buttonHolder.classList.add('gridAct');
	}

	removeLocalStoregeQuestion();
	const boolean = global.mobaleMOde && width <= 775;
	if (boolean) {
		let list = document.querySelector('.wrapperPagestart'),
			elem = document.querySelectorAll('.tinRightIn');
		if (elem) {
			elem = null;

			list.replaceChildren();
			// document.body.style.height  = height +'px'
		}
		wrapperTutle.classList.add('pps');
	}
	let time4 = setTimeout(
		() => {
			if (!boolean) {
				let list = document.querySelector('.wrapperPagestart'),
					elem = document.querySelectorAll('.tinRightIn');
				if (elem) {
					elem = null;

					list.replaceChildren();
					// document.body.style.height  = height +'px'
				}
			}
			localStorage.setItem('sel', sel);

			// window.selFoOpenAllquestion = sel;

			quetionAdd(false, sel);

			if (document.querySelector('[data-span2]')) {
				document.querySelector('[data-span2]').classList.remove('opal');
			}
			widjetCircolLev(sel);

			clearTimeout(time4);
			time4 = null;
		},
		boolean ? 400 : 800
	);
};

export default changeLevel;
